/**
 * This file holds static content associated with
 * pages/staticpage.js
 *
 * See the variable `staticContent` for the master variable
 * mapping page IDs to HTML and JSX elements.
 */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faScrewdriverWrench, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { RegionPicker } from "./components/regionpicker.js";
import { ImageViewModalWithZoom } from './components/imageviewmodalwithzoom.js';
import { VideoViewModal } from './components/videoviewmodal.js';
import heliopauseImg from "./images/entrypoint-content/H_0322_HeliopauseCycle_v01.00680_print.jpg";
import earthSunSystemImg from "./images/entrypoint-content/EarthSunSystem_HW_resized.jpg";
import solarEruptionImg from "./images/entrypoint-content/Magnificent_Eruption_Still_resized.jpg";
import missionFleetImg from "./images/entrypoint-content/mission-fleet.jpg";
import helioviewerCardImg from "./images/entrypoint-content/helioviewer_card.jpg";
import sswebCardImg from "./images/entrypoint-content/ssweb_card.jpg";
import sunImagesCardImg from "./images/entrypoint-content/sun_images_card.jpg";
import heliophysicsTourCardImg from "./images/entrypoint-content/heliophysics_tour_card.jpg";
import cdawebPlotExampleImg from "./images/entrypoint-content/cdaweb_plot_example.jpg";
import dataAccessExampleImg from "./images/entrypoint-content/data_access.jpg";
import datasetExampleImg from "./images/entrypoint-content/dataset_example.jpg";
import datasetListExampleImg from "./images/entrypoint-content/datasetlist_example.jpg";
import helioviewerExampleImg from "./images/entrypoint-content/helioviewer_example.jpg";
import pyPlotExampleImg from "./images/entrypoint-content/pyplot.jpg";
import hDRLImg from "./images/entrypoint-content/hdrl_hi_res_identifier.jpg";
import sPDFImg from "./images/entrypoint-content/spdf_image.jpg";
import parkerSolarProbe from "./images/entrypoint-content/parker-solar-probe.jpg";
import techsInCleanRoom from "./images/entrypoint-content/techs-in-clean-room.jpg";
import voyager1And2Data from "./images/entrypoint-content/voyager1-and-voyager2-data.jpg";
import solarFlareVid from "./images/entrypoint-content/solar-flare.webm";
import sohoVid from "./images/entrypoint-content/soho-video.webm";
import irisVid from "./images/entrypoint-content/iris-video.webm";
import windObservations from "./images/entrypoint-content/wind-observations.jpg";
import categorizedObservatoryData from './common/categorized_observatories_with_ids.json';


/**
 * Lorem ipsum text used as a placeholder.
 */
const lorumLong = [
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent iaculis metus quam, id tristique massa mollis quis. Phasellus sollicitudin mattis facilisis. Morbi convallis, odio in laoreet mollis, ex urna malesuada est, eu feugiat metus erat id tellus. Ut sit amet dui ultrices, aliquet lacus at, iaculis dolor. Fusce fringilla, justo vel lobortis posuere, nunc magna consectetur lectus, et vestibulum lectus augue dignissim arcu. Integer tincidunt odio at massa vestibulum pellentesque. Integer ex arcu, lobortis vitae urna sed, finibus euismod elit. Cras vel porta lacus.",
  "Interdum et malesuada fames ac ante ipsum primis in faucibus. Nunc porta arcu nulla, at gravida eros maximus vitae. Nam eu leo sagittis, laoreet neque ut, feugiat est. Vestibulum aliquam tincidunt condimentum. Sed pretium ipsum nec est laoreet fringilla. Vivamus massa quam, ultricies eget enim sit amet, accumsan accumsan mauris. Praesent et lorem neque. Proin fermentum eu velit sed dapibus. Morbi nec nibh in est pellentesque laoreet et vitae urna. Pellentesque suscipit feugiat efficitur. Vestibulum eu odio sit amet arcu congue posuere sed at nunc. Cras fermentum leo quis sollicitudin venenatis. Suspendisse sit amet ante efficitur eros viverra facilisis. Curabitur quis ipsum libero. Etiam lobortis pulvinar dolor, sit amet euismod massa cursus vitae. Morbi vel mattis nibh.",
  "Quisque in consectetur nisi. Pellentesque neque lectus, euismod eu ante ac, fringilla ultricies elit. Nunc porttitor pretium dapibus. Maecenas porta, libero vel eleifend luctus, metus nunc accumsan ex, et tristique risus eros ut velit. Etiam metus mauris, feugiat vel porta ac, porttitor ut tortor. Praesent risus mauris, ornare vitae arcu non, vestibulum rhoncus lacus. Praesent id est lacus. Cras at sagittis ligula. Morbi massa mauris, dignissim sed mi et, finibus rutrum neque.",
  "Aenean in iaculis ex. Sed fringilla massa sit amet lacinia fermentum. Integer hendrerit tortor feugiat felis rutrum, in viverra dolor accumsan. Morbi sit amet tincidunt neque, ut rutrum justo. Nunc purus sem, congue sit amet sagittis egestas, auctor id enim. Etiam aliquet tortor pulvinar erat dictum iaculis. Duis scelerisque lobortis tellus nec feugiat. Vivamus in rutrum nisl, sit amet vestibulum eros. Nulla eget massa vestibulum, placerat nisl ac, placerat metus. Fusce enim diam, lobortis a augue et, vulputate pellentesque elit. Cras imperdiet, arcu sit amet egestas vestibulum, dolor elit tincidunt ipsum, quis sollicitudin nibh neque a tortor. Donec tellus metus, sollicitudin a blandit id, maximus id eros. Mauris odio lacus, faucibus vel lectus sit amet, efficitur varius elit. Maecenas scelerisque quam vitae turpis ullamcorper, sit amet malesuada nunc tristique.",
  "Aenean sollicitudin pulvinar velit et dapibus. Etiam sodales rhoncus consectetur. Quisque sodales faucibus pulvinar. Aliquam et velit in erat semper cursus eget eget nunc. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Suspendisse odio arcu, pharetra nec varius et, fringilla rutrum ex. Nam semper dolor ac luctus viverra. Quisque tincidunt condimentum quam at finibus. Duis efficitur neque felis, elementum placerat ex hendrerit id. Morbi et dui eu libero euismod vehicula ac et massa.",
];

const lorumLongHtml = lorumLong.map(para => "<p>" + para + "</p>").join("\n");

const contactUsHtml = `
  <div class="contactForm">
    <div class="contactPageHeader">
      <h1>Contact Us</h1>
    </div>
    <div><p>The Heliodata team welcomes your feedback and questions about our website. We will get back to you as soon as possible.</p></div>
    <div><form id="contactForm" class="contactFormContainer">
      <div class="formGroup">
        <label>Name</label>
        <input type="text" name="name" placeholder="Your Name (required)" required />
      </div>

      <div class="formGroup">
        <label>Email</label>
        <input type="email" name="email" placeholder="Your Email (required)" required />
      </div>

      <div class="formGroup">
        <label>Subject</label>
        <input type="text" name="subject" placeholder="Subject (required)" required />
      </div>

      <div class="formGroup">
        <label>Message</label>
        <textarea name="message" placeholder="Your Message (required)" rows="10"  minlength="15" required></textarea>
      </div>

      <button type="submit" class="btnSubmit">Submit</button>
    </form>

    <p id="formSuccess" class="formMessage success hidden">
      Your message has been sent successfully!
    </p>
    <p id="formError" class="formMessage error hidden">
      Something went wrong. Please check your inputs and try again.
    </p></div>
  </div>
`;

/**
 * "Discover and download" page
 * This is a function that accepts a searchBar component to be embedded in Step 1
 */
const discoverAndDownloadPageHtml = (searchBar) => (
  <div className="stepGuideContainer">
    <div className="introSection">

      <h2 className="staticSectionHeading">Discover and Download Data</h2>

      <div className="introCalloutBox">
        <h3>Follow the steps below to:</h3>
        <ul>
          <li>Browse major datasets on the site oriented around key heliophysics missions.</li>
          <li>Link directly to services to download solar physics and space physics data in various formats.</li>
          <li>Explore common software analysis tools.</li>
        </ul>
      </div>

      <p>HelioData is a tool for discovering data and finding resources to work with data effectively. This service offers researchers a streamlined approach for locating heliophysics datasets and turning them into scientific plots and results.</p>

      <p>This site serves as an aggregator to lead you to the data you need and the tools that you want, with guidance and support from the heliophysics community each step of the way. HelioData is powered by data discovery services maintained by NASA's <a href="https://spdf.gsfc.nasa.gov/" target="_blank" rel="noreferrer">Space Physics Data Facility</a> (SPDF) and NASA's <a href="https://umbra.nascom.nasa.gov/index.html/" target="_blank" rel="noreferrer">Solar Data Analysis Center</a> (SDAC). Associated services for space physics data include the <a href="https://cdaweb.gsfc.nasa.gov/" target="_blank" rel="noreferrer">CDAWeb</a> data explorer and plotting system, the <a href="https://sscweb.gsfc.nasa.gov/" target="_blank" rel="noreferrer">SSCWeb</a> database of spacecraft trajectories with 4D orbit viewer capabilities, and the <a href="https://omniweb.gsfc.nasa.gov/" target="_blank" rel="noreferrer">OMNIWeb</a> database that includes solar wind data at Earth's bow shock nose and other locations of the heliosphere. Solar physics data discovery through HelioData is facilitated by the <a href="https://sdac.virtualsolar.org/cgi/search" target="_blank" rel="noreferrer">Virtual Solar Observatory (VSO)</a>.</p>
    </div>

    <div className="stepSection" data-step="1">
      <div className="stepHeader">
        <span className="stepBadge">1</span>
        <h2 className="stepTitle">Browse and Discover</h2>
      </div>
      <div className="stepContent">
        <p>HelioData hosts a growing collection of heliophysics data. Major remote-sensing and in-situ datasets from NASA missions, as well as other institutions are included on the site. There are also navigation links to external sites, such as mission pages and NASA's data archive, where heliophysics data from other NASA missions can be accessed, downloaded, and analyzed.</p>

        <h3>Browsing Methods</h3>
        <h4>Search Bar</h4>

        {searchBar}

        <p>Use the search bar function to input any research terms for a full-text search. You can also select from a QUICK SEARCH FIELD list above the search bar to explore within categories such as Mission, Instrument, and Dataset DOI. Click on the "All Fields" dropdown menu to see the full list of available search categories. After you select a QUICK SEARCH FIELD category, it will be inserted into the search bar automatically. There, you can fill in a specific search term (such as "MMS" or "Magnetospheric Multiscale Mission" for that mission's data) within the quotation marks that appear next to the field name.</p>

        <h4>Search by Mission or Observatory</h4>
        <p>Search through a <a href="/missionlist">full list</a> of available missions and observatories in the HelioData system. HelioData's archive includes over 2 petabytes of big data spanning more than 65 years of space exploration. This includes datasets from more than 600 instruments on more than 100 missions and observatories, including Parker Solar Probe and historic NASA missions such as Explorer 3, the oldest space science data archived at NASA.</p>


        <h4>Search by Region</h4>
        <p>You can also search by regions or subregions of space by navigating to the region pages including <a href="/region/sun">Solar Environment Data</a>, <a href="/region/interplanetary-space">Interplanetary Space Data</a>, <a href="/region/earth-magnetosphere">Earth Magnetosphere Data</a>, <a href="/region/earth-atmosphere">Earth Atmosphere Data</a>, and <a href="/region/planetary-magnetospheres">Planetary Magnetospheres Data</a>. These pages can also be accessed from the heliosphere image map on the home page. Featured missions associated with a region are also available to explore through those pages.</p>
      </div>
    </div>

    <div className="stepSection" data-step="2">
      <div className="stepHeader">
        <span className="stepBadge">2</span>
        <h2 className="stepTitle">Filter Results of a Search</h2>
      </div>
      <div className="stepContent">
        <div className="contentWithImage">
          <div className="contentText">
            <p>Your search query will produce a results page that lists all datasets associated with your search, including dataset titles, short summary information, and quick-access methods for downloading each dataset. You can filter the results further with the "Refine Search" sidebar to isolate instrument and data sources, measurement type, regions, time resolution, era, and/or access method.</p>
          </div>
          <div className="contentImage">
            <div className="embedded-graphic-section-canvas">
              <ImageViewModalWithZoom src={datasetListExampleImg} alt="dataset list" />
            </div>
            <div className="imageCaption">Click to enlarge</div>
          </div>
        </div>

        <div className="contentWithImage">
          <div className="contentText">
            <p>Click on any dataset title for more detailed information about a dataset, including a full description, summary of the metadata, variables contained in the dataset, additional access information, methods to cite the data, and documentation resources.</p>
          </div>
          <div className="contentImage">
            <div className="embedded-graphic-section-canvas">
              <ImageViewModalWithZoom src={datasetExampleImg} alt="dataset" />
            </div>
            <div className="imageCaption">Click to enlarge</div>
          </div>
        </div>
      </div>
    </div>

    <div className="stepSection" data-step="3">
      <div className="stepHeader">
        <span className="stepBadge">3</span>
        <h2 className="stepTitle">Download and Analyze</h2>
      </div>
      <div className="stepContent">
        <div className="contentWithImage">
          <div className="contentText">
            <p>Navigate to the "Data Access" box to explore methods for downloading, plotting, visualizing, and audifying data. Some datasets include a "Get Data" dropdown menu, which maps to either the <a href="https://cdaweb.gsfc.nasa.gov/" target="_blank" rel="noreferrer">CDAWeb</a> space physics data explorer and plotting system or the <a href="https://helioviewer.org/?fbclid=IwAR25oCw8ifghyGsW4CkDq25DwUw78Z_wu1ICf3ZPGH3akNuIMC78DSEfQgY" target="_blank" rel="noreferrer">Helioviewer </a>solar physics data visualization tool.</p>

            <p>Options for "FTP Download" or "HTTPS Download" may also be available depending on the dataset, as well as links to associated sites and services for downloading data.</p>

            <p>Primary data formats available include <a href="https://cdf.gsfc.nasa.gov/" target="_blank" rel="noreferrer">CDF</a>, <a href="https://fits.gsfc.nasa.gov/" target="_blank" rel="noreferrer">FITS</a>, <a href="https://www.ietf.org/rfc/rfc4180.txt" target="_blank" rel="noreferrer">CSV</a>, <a href="https://www.unidata.ucar.edu/software/netcdf/" target="_blank" rel="noreferrer">NetCDF</a>, and <a href="https://www.hdfgroup.org/solutions/hdf5/" target="_blank" rel="noreferrer">HDF</a>.</p>

          </div>
          <div className="contentImage">
            <div className="embedded-graphic-section-canvas">
              <ImageViewModalWithZoom src={dataAccessExampleImg} alt="data access box" small={true} />
            </div>
            <div className="imageCaption">Example from ACE mission</div>
          </div>
        </div>

        <div className="contentWithImage">
          <div className="contentText">
            <p>For space physics data, click on variables of interest and select "Plot Data" to generate a data plot, or select "Download Data Files" to save from a list of available formats. You can also select "Download Audio Files" to access audified data. Audification is a specific type of data sonification that involves the isomorphic (i.e., one-to-one) mapping of data samples to audio samples. When an audified dataset is played over speakers or headphones, spectral features within the original data are translated as timbral components in the resulting audio.</p>
          </div>
          <div className="contentImage">
            <div className="embedded-graphic-section-canvas">
              <ImageViewModalWithZoom src={cdawebPlotExampleImg} alt="cdaweb plot" />
            </div>
            <div className="imageCaption">Click to enlarge</div>
          </div>
        </div>

        <div className="contentWithImage">
          <div className="contentText">
            <p>For some solar physics datasets, the web-based data visualization tool Helioviewer is integrated into the image data. Select "Visualize Data"  to open the Helioviewer modal, enter a time of interest, and click "Find Image" to view and download the image for that timestamp. You can also select "Open in Helioviewer" to open your selection directly on the <a href="https://www.helioviewer.org" target="_blank" rel="noreferrer">Helioviewer.org</a> site with expanded capabilities, including options to view images of the Sun from different spacecraft instruments, overlay features and events, and make screenshots and movies of solar phenomena. You can alternatively select "Open VSO" to access the image data directly in the <a href="https://sdac.virtualsolar.org/cgi/search" target="_blank" rel="noreferrer">Virtual Solar Observatory (VSO)</a> discovery service. Please note most solar image data are observed at wavelengths that are not visible light, so the raw data has been processed and assigned unique colors to represent different wavelengths. Each wavelength reveals different solar features.</p>
          </div>
          <div className="contentImage">
            <div className="embedded-graphic-section-canvas">
              <ImageViewModalWithZoom src={helioviewerExampleImg} alt="helioviewer" />
            </div>
            <div className="imageCaption">Click to enlarge</div>
          </div>
        </div>

        <div className="contentWithImage">
          <div className="contentText">
            <h3>Software Packages</h3>
            <p>After downloading, a selection of popular software packages are available for working with the datasets in the <a href="https://www.python.org/" target="_blank" rel="noreferrer">Python</a> and <a href="https://www.nv5geospatialsoftware.com/Products/IDL" target="_blank" rel="noreferrer">Interactive Data Language</a> (IDL) programming languages.</p>
            <p>Popular Python software packages include <a href="https://spacepy.github.io/" target="_blank" rel="noreferrer">SpacePy</a>, <a href="https://sunpy.org/help" target="_blank" rel="noreferrer">SunPy</a>, <a href="https://cdflib.readthedocs.io/en/latest/" target="_blank" rel="noreferrer">CDFLib</a>, <a href="https://pyspedas.readthedocs.io/en/latest/" target="_blank" rel="noreferrer">PySPEDAS</a>, <a href="https://www.astropy.org/" target="_blank" rel="noreferrer">Astropy</a> (for FITS files), and <a href="https://www.h5py.org/" target="_blank" rel="noreferrer">h5py</a> (for HDF files). The Python in Heliophysics Community (<a href="https://heliopython.org/" target="_blank" rel="noreferrer">PyHC</a>) is a NASA-supported project that promotes the use and development of sustainable open-source Python software for heliophysics research. Explore PyHC for a variety of tutorials, resources, a list of useful packages, general discussion, and advice about using the free and open-source software.</p>

            <p>Popular IDL software packages include <a href="https://www.lmsal.com/solarsoft/" target="_blank" rel="noreferrer">SolarSoft</a> and <a href="https://spedas.org/blog/" target="_blank" rel="noreferrer">SPEDAS</a>.</p>
          </div>
          <div className="contentImage">
            <div className="embedded-graphic-section-canvas">
              <ImageViewModalWithZoom src={pyPlotExampleImg} alt="plot" />
            </div>
            <div className="imageCaption">Click to enlarge</div>
            <div className="embedded-graphic-caption-left">
              <div>The left panel shows an image of the Sun captured in a wavelength of extreme ultraviolet light at 171 angstroms by the Atmospheric Imaging Assembly (AIA) instrument on NASA's Solar Dynamics Observatory (SDO) spacecraft. The right panel shows the same image reprojected from a different vantage point using the reprojection capabilities available with SunPy open-source software.<br></br>
                Credit: AIA data courtesy of NASA/SDO and the AIA, EVE, and HMI science teams. Image created using version 5.0.0 of the SunPy open-source software package (DOI: 10.5281/zenodo.8037332)</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="stepSection">
      <div className="stepHeader">
        <h2 className="stepTitle">Open Science Resources</h2>
      </div>
      <div className="stepContent">
        <p><a href="https://science.nasa.gov/open-science/" target="_blank" rel="noreferrer">Open science</a> is an available, collaborative, transparent, and reproducible way of doing science that is enabled by technology. This movement empowers the open sharing of data, information, and knowledge within the scientific community and the wider public to accelerate scientific research, understanding, and discovery. An open science culture recognizes that great science is strengthened by detailed critique and welcomes it. This culture acknowledges, with citations, that scientific breakthrough is achieved by standing on the shoulders of previous accomplishments.</p>

        <p>The resources linked below guide heliophysics researchers in producing Digital Object Identifiers (DOIs) with useful metadata, including citations to the resources critical to each work, such as datasets, software, publications and presentation posters.</p>

        <div className="resourceCardGrid">
          <a className="resourceCard" href="https://zenodo.org/records/20027863" target="_blank" rel="noreferrer">
            <span className="resourceCardText">
              <h4>How to Create a Quality DOI for NASA Research Artifacts</h4>
              <p>Explore a guide to creating DOIs with useful metadata so others can directly cite your research artifacts.</p>
            </span>
            <span className="resourceCardIcon" aria-hidden="true">
              <FontAwesomeIcon icon={faArrowRight} />
            </span>
          </a>
          <a className="resourceCard" href="https://zenodo.org/records/20027689" target="_blank" rel="noreferrer">
            <span className="resourceCardText">
              <h4>How-To: Citing Critical Artifacts</h4>
              <p>Learn to properly cite research artifacts, including data and software, to help shine light on the technical talent supporting scientific discovery.</p>
            </span>
            <span className="resourceCardIcon" aria-hidden="true">
              <FontAwesomeIcon icon={faArrowRight} />
            </span>
          </a>
        </div>
      </div>
    </div>

    <div className="troubleshootingSection">
      <span className="troubleshootingIcon" aria-hidden="true">
        <FontAwesomeIcon icon={faScrewdriverWrench} />
      </span>
      <div className="troubleshootingText">
        <h2 className="staticSectionHeading">Troubleshooting and Support</h2>
        <p>For help using the HelioData website, or to share feedback with the team, reach us by email.</p>
      </div>
      <a className="troubleshootingCta" href="mailto:heliodata-support-owner@lists.nasa.gov">
        <FontAwesomeIcon icon={faEnvelope} aria-hidden="true" />
        Contact us
      </a>
    </div>
  </div>
);



/**
 * "About" page
 */
const aboutPageHtml = (
  <div className="hdrlPage">

    {/* ===== Intro row: text + hero image ===== */}
    <section className="hdrlIntro">
      <div className="hdrlIntroText">
        <h2 className="staticSectionHeading">Empowering the Heliophysics Research Community</h2>
        <p>HelioData is NASA's modernized system for heliophysics data discovery. It is a project supported and funded by NASA's Heliophysics Digital Resource Library (HDRL). HDRL provides open-access gateways to thousands of datasets from current and historic <a href="https://science.nasa.gov/heliophysics/missions/mission-fleet-diagram/" target="_blank" rel="noreferrer">NASA Heliophysics missions</a> while enabling sophisticated cross-mission analysis and observation-model comparison. HDRL embraces NASA's commitment to an inclusive, <a href="https://science.nasa.gov/researchers/open-science/" target="_blank" rel="noreferrer">open science</a> community and has adopted community standards, such as <a href="https://spase-group.org/" target="_blank" rel="noreferrer">Space Physics Archive Search and Extract (SPASE)</a> and the <a href="https://spdf.gsfc.nasa.gov/sp_use_of_cdf.html" target="_blank" rel="noreferrer">International Solar-Terrestrial Physics (ISTP)</a> metadata guidelines to unify heliophysics datasets, analysis tools, and other resources with consistent descriptions for easy access. This massive data repository supports researchers in their quests to unlock groundbreaking scientific discoveries about the nature of the relationship between the Sun, planets, asteroids, comets, and space environment as a dynamic system.</p>
      </div>
      <div className="hdrlIntroMedia">
        <img src={hDRLImg} alt="The Heliophysics Digital Resource Library (HDRL) identifier graphic" className="hdrlIntroImg" />
      </div>
    </section>

    {/* ===== HDRL Members ===== */}
    <h2 className="staticSectionHeading" id="hdrl-members">HDRL Members</h2>
    <div className="hdrlMembersGrid">

      {/* SDAC */}
      <article className="hdrlMemberCard">
        <figure className="hdrlMemberCardMedia">
          <ImageViewModalWithZoom src={solarEruptionImg} alt="Solar filament eruption captured by NASA's Solar Dynamics Observatory (SDO) spacecraft" className="hdrlMemberCardImg" />
          <figcaption className="hdrlMemberCaption">A filament eruption on the Sun captured by NASA's Solar Dynamics Observatory (SDO) spacecraft. Credit: NASA's Goddard Space Flight Center.</figcaption>
        </figure>
        <div className="hdrlMemberCardBody">
          <h3 id="solar-data-analysis-center-sdac">Solar Data Analysis Center (SDAC)</h3>
          <p>The <a href="https://umbra.nascom.nasa.gov/index.html/" target="_blank" rel="noreferrer">Solar Data Analysis Center (SDAC)</a> supports the analysis of solar physics data. The SDAC stores and provides data from NASA's solar physics missions. The bulk of these data are captured using remote-sensing instruments, which observe processes within the Sun's layers and track activity as it expands into the heliosphere. These data help us understand the physics of the Sun and help predict the Sun's effects on Earth and our atmosphere. SDAC supports visualization tools (including <a href="https://helioviewer.org/?fbclid=IwAR25oCw8ifghyGsW4CkDq25DwUw78Z_wu1ICf3ZPGH3akNuIMC78DSEfQgY" target="_blank" rel="noreferrer">Helioviewer</a>), the <a href="http://www.lmsal.com/solarsoft/" target="_blank" rel="noreferrer">SolarSoft</a> software library used for data analysis, and the <a href="https://sdac.virtualsolar.org/cgi/search" target="_blank" rel="noreferrer">Virtual Solar Observatory (VSO)</a> discovery service to search and download solar physics data products from around the world.</p>
        </div>
      </article>

      {/* SPDF */}
      <article className="hdrlMemberCard">
        <figure className="hdrlMemberCardMedia">
          <ImageViewModalWithZoom src={sPDFImg} alt="Conceptual illustration of Parker Solar Probe near the Sun" className="hdrlMemberCardImg" />
          <figcaption className="hdrlMemberCaption">This conceptual image shows Parker Solar Probe flying close to the Sun. Credit: NASA/JHUAP</figcaption>
        </figure>
        <div className="hdrlMemberCardBody">
          <h3 id="space-physics-data-facility-spdf">Space Physics Data Facility (SPDF)</h3>
          <p>The <a href="https://spdf.gsfc.nasa.gov/" target="_blank" rel="noreferrer">Space Physics Data Facility</a> is NASA's archive for non-solar heliophysics data, often called space physics data, from heliophysics missions. These data are retrieved from in situ measurements of plasma, energetic particles, magnetic and electric fields, and radio and plasma waves in the interplanetary space and the space environment of Earth and other planets. The space physics investigations aim to better understand how the solar phenomena and resultant space weather impact space environments of Earth and other objects in the solar system. SPDF maintains the <a href="https://cdaweb.gsfc.nasa.gov/" target="_blank" rel="noreferrer">CDAWeb</a> data explorer and plotting system, the <a href="https://sscweb.gsfc.nasa.gov/" target="_blank" rel="noreferrer">SSCWeb</a> database of spacecraft trajectories with 4D orbit viewer capabilities, the <a href="https://omniweb.gsfc.nasa.gov/" target="_blank" rel="noreferrer">OMNIWeb</a> database that includes solar wind data at Earth's bow shock nose and other locations of the heliosphere, and the <a href="https://cdf.gsfc.nasa.gov/" target="_blank" rel="noreferrer">Common Data Format (CDF)</a> self-describing science data format and associated software.</p>
        </div>
      </article>

      {/* DISH (formerly HDMC) — full-width text card; id retains the legacy slug for existing anchors */}
      <article className="hdrlMemberCard hdrlMemberCardWide">
        <div className="hdrlMemberCardBody">
          <h3 id="heliophysics-data-and-model-consortium-hdmc">Data Integration and Services for Heliophysics (DISH)</h3>
          <div className="hdrlDishLayout">
            <p>DISH supports the development of software and services to help promote greater synergy between SDAC, SPDF, and the larger heliophysics community. This entity serves as a catalyst for carrying out HDRL's mission to yield the greatest value of research from NASA's heliophysics missions. DISH supports initiatives in open science and community outreach while DISH grants include support for collaborators such as <a href="https://heliopython.org/" target="_blank" rel="noreferrer">PyHC</a>, <a href="https://spedas.org/blog/" target="_blank" rel="noreferrer">SPEDAS</a>, <a href="http://autoplot.org/" target="_blank" rel="noreferrer">Autoplot</a>, and <a href="http://heliocloud.org/" target="_blank" rel="noreferrer">HelioCloud</a>. DISH also provides support for heliophysics data standards, registration, and discovery of overall HDRL resources.</p>
            <div className="hdrlDishQuote" aria-hidden="true">
              <p>A catalyst for carrying out HDRL's mission to yield the greatest value of research from NASA's heliophysics missions.</p>
            </div>
          </div>
        </div>
      </article>

    </div>
  </div>
);




/**
 * "Learn about Heliophysics" page
 */
const learnAboutHelioHtml = (
  <div className="learnPageContainer">

    {/* ===== Section 1: Welcome to Heliophysics! ===== */}
    <div className="learnSection">
      <div className="learnMediaFloat learnMediaFloatRight">
        <ImageViewModalWithZoom src={heliopauseImg} alt="Heliopause" />
        <div className="learnMediaCaption">
          A conceptual image showing the heliosphere — the vast bubble that is generated by
          the Sun's magnetic field and envelops all the planets.
          Credit: NASA's Goddard Space Flight Center Conceptual Image Lab
        </div>
      </div>
      <h2 className="staticSectionHeading">An Exciting, Interdisciplinary Research Field</h2>
      <p>
        Heliophysics invites researchers to explore the nature of the relationship between the Sun, planets, asteroids, comets, and the space environment as a dynamic system. The field embraces NASA's commitment to open science and shared data access. This critical work helps to mitigate the impacts of space weather events on civilization and is crucial for ensuring the safety of human spaceflight as NASA embarks on exploration to the Moon, Mars, and beyond.
      </p>
    </div>

    {/* ===== Section 2: A Unifying Vision ===== */}
    <div className="learnSection learnSectionAlt">
      <div className="learnMediaFloat learnMediaFloatLeft">
        <ImageViewModalWithZoom src={earthSunSystemImg} alt="Earth and sun system" />
        <div className="learnMediaCaption">
          Illustration depicts Sun-Earth interactions that influence space weather.
          Credit: NASA's Goddard Space Flight Center
        </div>
      </div>
      <h2 className="staticSectionHeading">A Unifying Vision</h2>
      <p>
        The term heliophysics emerged at NASA in the early 2000s from a vision within the
        agency to integrate the study of the Sun, Earth, planets, and the heliosphere — a
        protective bubble of particles and magnetic fields that surrounds the solar system.
        Scientists cultivated a unified strategy to better understand solar, plasma, and
        electromagnetic phenomena and resultant interplanetary space weather conditions.
        Heliophysics brings together specialists in formerly separate science disciplines
        working to advance the concept that the structure of the solar system is determined
        by the interplay of gravity and magnetism through fundamental physical processes such
        as dynamos, plasma flows, magnetic reconnection, and particle acceleration. The
        alliance breaks down barriers to collaboration and supports a harmonized systems
        science to examine the Sun-Earth connection through the lens of plasma physics. The
        growing heliophysics community of dedicated solar and space physics scientists also
        welcomes engineering and computer programming specialists to support the rising
        convergence of science and technology in the field.
      </p>
    </div>

    {/* ===== Section 3: Protecting People and Technology ===== */}
    <div className="learnSection">
      <div className="learnMediaFloat learnMediaFloatRight">
        <VideoViewModal
          src="https://svs.gsfc.nasa.gov/vis/a000000/a005100/a005193/multiField_11-30-2023a_magnetosphere_anim_1080p30.mp4"
          type="video/mp4"
          autoPlay
          caption="Earth's magnetosphere being hit by a geomagnetic storm on February 3, 2020, simulated by MAGE during the storm that caused the loss of commercial satellites."
          credit="Credit: NASA Scientific Visualization Studio (SVS)."
        />
      </div>
      <h2 className="staticSectionHeading">Protecting People and Technology</h2>
      <p>
        Heliophysicists study the physical processes that drive the space environment through
        observing, analyzing, and modeling data from a fleet of missions placed throughout the
        solar system. Examining the solar wind, which is the stream of charged particles
        released from the Sun, and its connection to space weather is a core component of
        heliophysics. This sustained solar wind, along with intermittent solar events like
        giant explosions called coronal mass ejections, influences the very nature of space
        and can interact with the magnetic systems of Earth and other planets. These effects
        also change the radiation environment through which our spacecraft and astronauts
        travel. Heliophysics is a key player in the grand mission of human spaceflight in a
        new era of space exploration. The space environment around Earth is also vulnerable
        to space weather, which can interfere with satellite electronics, radio communications
        and GPS signals, spacecraft orbits, and power grids on Earth. Strengthening space
        weather analysis and prediction is a leading objective of heliophysics research.
      </p>
    </div>

    {/* ===== Section 4: Exploring the Sun + RegionPicker (unchanged) ===== */}
    <div className="learnSection">
      <h2 className="staticSectionHeading">Exploring the Sun, the Solar Wind, and the Magnetosphere</h2>
      <p>
        Many researchers who join NASA's heliophysics division focus on a specific region,
        such as the solar interior, solar surface, solar atmosphere, solar wind, Earth's
        magnetosphere, or Earth's upper atmosphere. Key phenomena within a region, such as
        solar energetic particles or geomagnetic storms, may also be a focal point of
        research, with many opportunities for overlap. HelioData organizes data and its
        associated phenomena into distinct areas of study within the heliosphere.
      </p>
      <RegionPicker />
    </div>

    {/* ===== Section 5: Discovery and Exploration ===== */}
    <div className="learnSection learnSectionAlt">
      <div className="learnMediaFloat learnMediaFloatRight">
        <ImageViewModalWithZoom src={solarEruptionImg} alt="Solar eruption" />
        <div className="learnMediaCaption">
          An eruption on the Sun captured by NASA's Solar Dynamics Observatory (SDO) spacecraft.
          Credit: NASA's Goddard Space Flight Center.
        </div>
      </div>
      <h2 className="staticSectionHeading">Discovery and Exploration</h2>
      <p>
        Fundamental achievements in heliophysics include identifying that the Sun goes through
        11-year cycles of fluctuating solar activity, referred to as the solar cycle, and
        discovery of the <a href="/region/solar-wind">solar wind</a>. Heliophysics research
        revealed the existence of the heliosphere, marked the connection between the Sun and
        the aurora, theorized that sunspots are created by changes in the Sun's magnetic
        field, and led to the discovery of the Van Allen Belts, trapped particles of radiation
        that surround the Earth and can endanger spacecraft. Eclipse science supported by
        heliophysics research has enabled the visibility of solar prominences and confirmation
        of relativity.
      </p>

      {/* ---- Variant A: Dark Space Grid ---- */}
      <div className="learnQuestionsA">
        <div className="learnQuestionsALabel">Evolving research questions explored in heliophysics include:</div>
        <div className="learnQuestionsAGrid">
          <div className="learnQuestionACard">
            <span className="learnQuestionAIcon">?</span>
            <span className="learnQuestionAText">How does the Sun's corona get heated to millions of degrees?</span>
          </div>
          <div className="learnQuestionACard">
            <span className="learnQuestionAIcon">?</span>
            <span className="learnQuestionAText">How does the solar wind connect to what's happening on the surface of the Sun?</span>
          </div>
          <div className="learnQuestionACard">
            <span className="learnQuestionAIcon">?</span>
            <span className="learnQuestionAText">What magnetic processes power the aurora and how does the aurora transition through different points of the magnetosphere?</span>
          </div>
          <div className="learnQuestionACard">
            <span className="learnQuestionAIcon">?</span>
            <span className="learnQuestionAText">How can the intensity of solar cycles be predicted?</span>
          </div>
          <div className="learnQuestionACard">
            <span className="learnQuestionAIcon">?</span>
            <span className="learnQuestionAText">How can solar images predict the structure of the solar wind that is going to arrive at Earth?</span>
          </div>
          <div className="learnQuestionACard">
            <span className="learnQuestionAIcon">?</span>
            <span className="learnQuestionAText">How can new advances in artificial intelligence and machine learning enhance studying the science of the Sun?</span>
          </div>
        </div>
      </div>

    </div>

    {/* ===== Section 6: Dive into Data ===== */}
    <div className="learnSection">
      <h2 className="staticSectionHeading">Dive into Data</h2>
      <p>
        NASA's HelioData website invites novice and seasoned researchers alike to explore open
        access pathways to heliophysics data through open science. Thousands of datasets from
        current and historic <a href="https://science.nasa.gov/heliophysics/missions/mission-fleet-diagram/" target="_blank" rel="noreferrer">NASA Heliophysics missions</a> and
        a selection of data from the <a href="https://www.noaa.gov/" target="_blank" rel="noreferrer">National Oceanic and Atmospheric Administration (NOAA)</a> are
        accessible through HelioData. Explore the site for more pathways to discovery.
      </p>
    </div>

  </div>
);


/**
 * "Where the Data Comes From" page
 */
const whereTheDataComesFromHtml = (
  <div className="whereDataPage">

    {/* ── Section 1: Intro ───────────────────────────────────────────────── */}
    <section className="whereDataSection">
      <div className="whereDataIntroRow">
        <div className="whereDataIntroText">
          <h2 className="staticSectionHeading staticSectionHeadingOnDark">Instrumentation</h2>
          <p className="whereDataIntroBody">
            NASA's Heliophysics Division supports instrumentation on and around Earth, at the Sun, throughout the solar system, and across the threshold into interstellar space. Spacecraft are positioned in different areas of the heliosphere to measure key phenomena to gain a deeper understanding of the heliosphere and how it impacts us here on Earth. Various instruments detect photons, magnetic fields, electric fields, or charged particles and transform the signal into data that can be analyzed in the pursuit of scientific discovery.
          </p>
        </div>
        <div className="whereDataIntroImagePane">
          <ImageViewModalWithZoom src={missionFleetImg} alt="Mission fleet" />
          <p className="whereDataMediaCaption">
            This graphic shows the current, active Heliophysics Division fleet, with green indicating missions in primary operation and blue indicating missions in extended operation. HelioData not only provides data from active missions but also offers open access to data from past missions spanning more than 65 years, including datasets from more than 600 instruments. Credit: NASA's Goddard Space Flight Center
          </p>
        </div>
      </div>
    </section>

    {/* ── Section 2: Types of Data Collection ───────────────────────────── */}
    <section className="whereDataSection whereDataSectionAlt">
      <h2 className="staticSectionHeading">Types of Data Collection</h2>

      <div className="whereDataTypeGrid">
        <div className="whereDataTypeCard">
          <div className="whereDataTypeIcon"><svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 512 512">{/* !Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc. */}<path fill="rgb(255, 255, 255)" d="M232 0c154.6 0 280 125.4 280 280 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-128.1-103.9-232-232-232-13.3 0-24-10.7-24-24S218.7 0 232 0zM208 120c0-13.3 10.7-24 24-24 101.6 0 184 82.4 184 184 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-75.1-60.9-136-136-136-13.3 0-24-10.7-24-24zM26.4 142.7c8.8-17.9 32.4-19.9 46.5-5.8l128.5 128.5 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32 128.5 128.5c14.1 14.1 12 37.6-5.8 46.5-34.2 16.9-72.6 26.4-113.3 26.4-141.4 0-256-114.6-256-256 0-40.7 9.5-79.2 26.4-113.3z" /></svg></div>
          <h3 className="whereDataTypeCardTitle">Remote-Sensing Spacecraft</h3>
          <p className="whereDataTypeCardBody">
            Remote-sensing (indirect-sensing from afar) instruments observe processes within the Sun's layers and track solar material as it expands into the heliosphere. NASA's solar physics missions capture data primarily using remote-sensing instruments, which characterize the source of distant phenomena as their traveling signals enter the device. The collected data helps researchers understand the physics of the heliosphere and helps predict the Sun's effects on Earth, our atmosphere, and other planets.
          </p>
        </div>

        <div className="whereDataTypeCard">
          <div className="whereDataTypeIcon"><svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 512 512">
            {/* !Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc. */}
            <path fill="rgb(255, 255, 255)" d="M199 7c9.4-9.4 24.6-9.4 33.9 0l89.4 89.4 55-55c12.5-12.5 32.8-12.5 45.3 0l48 48c12.5 12.5 12.5 32.8 0 45.3l-55 55 89.4 89.4c9.4 9.4 9.4 24.6 0 33.9l-96 96c-9.4 9.4-24.6 9.4-33.9 0l-89.4-89.4-15.5 15.5c11.4 24.6 17.8 52 17.8 80.9 0 31.7-7.7 61.5-21.2 87.8-4.7 9-16.7 10.3-23.8 3.1l-96.3-96.3-60 60c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l60-60-96.3-96.3c-7.2-7.2-5.9-19.2 3.1-23.8 26.3-13.6 56.2-21.2 87.8-21.2 28.9 0 56.3 6.4 80.9 17.8L192.4 226.3 103 137c-9.4-9.4-9.4-24.6 0-33.9L199 7zm17 50.9l-62.1 62.1 72.4 72.4 62.1-62.1-72.4-72.4zM392 358.1l62.1-62.1-72.4-72.4-62.1 62.1 72.4 72.4z" />
          </svg></div>
          <h3 className="whereDataTypeCardTitle">In-Situ Spacecraft</h3>
          <p className="whereDataTypeCardBody">
            In-situ (direct-sensing at the location of the spacecraft) instruments measure various phenomena including properties of plasmas, energetic particles, magnetic and electric fields, and electromagnetic and plasma waves. NASA's space physics missions mainly use in-situ instruments to capture measurements throughout the heliosphere ranging from the space environment around Earth, to other planets in our solar system, and into interplanetary space and beyond. These space physics investigations aim to better understand how the solar phenomena, and resultant space weather, can impact the space environments of Earth and other objects in the solar system.
          </p>
        </div>

        <div className="whereDataTypeCard">
          <div className="whereDataTypeIcon"><svg xmlns="http://www.w3.org/2000/svg" height="20" width="17.5" viewBox="0 0 448 512">{/* !Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.*/}<path fill="rgb(255, 255, 255)" d="M82.6 76.1c-3.8-5.1-8.7-9.4-14.2-12.5s-11.7-5.1-18.1-5.7-12.8 .1-18.8 2.2-11.6 5.3-16.3 9.6c-17.6 16.2-19 43.5-4.8 62.8l91.8 123-92.3 124.1c-14.2 19.3-13.1 46.6 4.7 62.8 4.7 4.3 10.3 7.6 16.3 9.6s12.5 2.8 18.8 2.2 12.5-2.5 18.1-5.7 10.4-7.4 14.2-12.5L210.9 262.7c1.5-2.1 2.3-4.6 2.3-7.1s-.8-5-2.3-7.1L82.6 76.1zM438.2 379.6l-92.3-124.1 91.8-123c14.2-19.2 12.8-46.6-4.7-62.8-4.7-4.3-10.3-7.6-16.3-9.6s-12.5-2.8-18.8-2.2-12.5 2.5-18.1 5.7-10.4 7.4-14.2 12.5l-128 172.1c-1.5 2.1-2.3 4.6-2.3 7.1s.8 5 2.3 7.1L366 435.9c3.8 5.1 8.7 9.4 14.2 12.5s11.7 5.1 18.1 5.7 12.8-.1 18.8-2.2 11.6-5.3 16.3-9.6c17.8-16.2 19-43.5 4.7-62.8z" /></svg></div>
          <h3 className="whereDataTypeCardTitle">Remote-Sensing &amp; In-Situ Mixed Spacecraft</h3>
          <p className="whereDataTypeCardBody">
            Some spacecraft embody a unique style of mixed mission with both remote sensing and in-situ components. An example of this type of spacecraft is the revolutionary <a href="/mission/ParkerSolarProbe">Parker Solar Probe</a>, soaring closer to the Sun than any other spacecraft ever has before.
          </p>
        </div>

        <div className="whereDataTypeCard">
          <div className="whereDataTypeIcon"><svg xmlns="http://www.w3.org/2000/svg" height="20" width="17.5" viewBox="0 0 448 512">{/* !Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc. */}<path fill="rgb(255, 255, 255)" d="M0 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm168 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm224-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z" /></svg></div>
          <h3 className="whereDataTypeCardTitle">Other Types of Experiments/Missions</h3>
          <p className="whereDataTypeCardBody">
            Additional methods of collecting scientific measurements include ground and low-altitude based experiments carried out by scientific balloons, rockets, and <a href="https://www.nasa.gov/what-are-smallsats-and-cubesats/" target="_Blank" rel="noreferrer">CubeSats</a> (a class of small satellites). Ground-based instrumentation measures observables such as magnetic fields and particles or phenomena like the aurora.
          </p>
        </div>
      </div>

      <div className="whereDataCollectionHero">
        <ImageViewModalWithZoom src={parkerSolarProbe} alt="Parker solar probe" />
        <p className="whereDataMediaCaption">
          Parker Solar Probe uses remote and direct measurements to collect data about the Sun.<br />
          Credit: NASA's Conceptual Image Lab
        </p>
      </div>
    </section>

    {/* ── Section 3: Science and Engineering Converge ───────────────────── */}
    <section className="whereDataSection">
      <h2 className="staticSectionHeading">Science and Engineering Converge</h2>
      <div className="whereDataEngineerBanner">
        <ImageViewModalWithZoom src={techsInCleanRoom} alt="Tech in clean room" className="whereDataEngineerImg" />
        <div className="whereDataEngineerOverlay">
          <p className="whereDataEngineerOverlayText">
            NASA empowers science and engineering on a unified front. Teams work behind the scenes designing space flight hardware, building and testing spacecraft, operating and maintaining satellites from Earth, processing the raw data, and providing services that allow scientists to access and analyze these data.
          </p>
        </div>
      </div>
      <p className="whereDataMediaCaption">
        Technicians preparing for the solar array deployment on the AIM spacecraft inside a clean-room at North Vandenberg Air Force Base in 2007.<br />
        Credit: NASA
      </p>
    </section>

    {/* ── Section 4: Types of Instrumentation ──────────────────────────── */}
    <section className="whereDataSection whereDataSectionAlt">
      <h2 className="staticSectionHeading">Types of Instrumentation</h2>
      <p className="whereDataInstrIntro">
        A diverse array of instruments enable science experiments that contribute to a greater understanding of the heliosphere. Here is a condensed list of commonly used <a href="https://science.nasa.gov/learn/basics-of-space-flight/chapter12-1/" target="_Blank" rel="noreferrer">science instruments</a> and some associated missions and phenomena.
      </p>

      <div className="whereDataInstrGrid">

        {/* Card 1: Imager */}
        <div className="whereDataInstrCard">
          <h3 className="whereDataInstrCardTitle">Imager</h3>
          <p className="whereDataInstrCardDesc">
            A remote-sensing instrument similar to a camera that uses optics such as lenses or mirrors to project an image onto a detector, where it is converted to digital data to form an image of a phenomenon. Different types of imagers can depict extreme ultraviolet radiation, X-ray, radio, heliospheric, polarimetric, or helioseismic images.
          </p>
          <div className="whereDataInstrCardBody">
            <div className="whereDataInstrCardCol">
              <p className="whereDataInstrListLabel">Phenomena observed:</p>
              <ul className="static-data-ul">
                <li>Solar active regions</li>
                <li>Prominences</li>
                <li>Airglow/aurora</li>
              </ul>
            </div>
            <div className="whereDataInstrCardCol">
              <p className="whereDataInstrListLabel">Mission Examples:</p>
              <ul className="static-data-ul">
                <li><a href="https://science.nasa.gov/mission/soho/" target="_Blank" rel="noreferrer">SOHO</a></li>
                <li><a href="https://science.nasa.gov/mission/sdo/" target="_Blank" rel="noreferrer">SDO</a></li>
                <li><a href="https://science.nasa.gov/mission/parker-solar-probe/" target="_Blank" rel="noreferrer">Parker Solar Probe</a></li>
                <li><a href="https://science.nasa.gov/mission/awe/" target="_Blank" rel="noreferrer">AWE</a></li>
              </ul>
            </div>
          </div>
          <div className="whereDataInstrCardMedia">
            <VideoViewModal
              src={solarFlareVid}
              type="video/webm"
              autoPlay
              caption="An image sequence showing a solar flare, prominence eruption and coronal mass ejection captured by the Solar Dynamics Observatory (SDO) on June 7, 2011."
              credit="Credit: NASA Scientific Visualization Studio."
            />
          </div>
        </div>

        {/* Card 2: Coronograph */}
        <div className="whereDataInstrCard">
          <h3 className="whereDataInstrCardTitle">Coronograph</h3>
          <p className="whereDataInstrCardDesc">
            A remote-sensing telescope that creates an artificial eclipse by using a round disk to block out the light from the Sun (the same way the Moon does during an eclipse) and reveal parts of the Sun's atmosphere that are normally too dim to see.
          </p>
          <div className="whereDataInstrCardBody">
            <div className="whereDataInstrCardCol">
              <p className="whereDataInstrListLabel">Phenomena observed:</p>
              <ul className="static-data-ul">
                <li>Solar events like coronal mass ejections</li>
                <li>Comets</li>
              </ul>
            </div>
            <div className="whereDataInstrCardCol">
              <p className="whereDataInstrListLabel">Mission Examples:</p>
              <ul className="static-data-ul">
                <li><a href="https://science.nasa.gov/mission/soho/" target="_Blank" rel="noreferrer">SOHO</a></li>
                <li><a href="https://science.nasa.gov/mission/stereo/" target="_Blank" rel="noreferrer">STEREO A &amp; B</a></li>
                <li><a href="https://science.nasa.gov/mission/solar-orbiter/" target="_Blank" rel="noreferrer">Solar Orbiter</a></li>
              </ul>
            </div>
          </div>
          <div className="whereDataInstrCardMedia">
            <VideoViewModal
              src={sohoVid}
              type="video/webm"
              autoPlay
              caption="This movie plays nearly two weeks of SOHO/EIT and SOHO/LASCO imagery from around Halloween 2003."
              credit="Credit: NASA/Goddard Space Flight Center Scientific Visualization Studio"
            />
          </div>
        </div>

        {/* Card 3: Electromagnetic Spectrometer */}
        <div className="whereDataInstrCard">
          <h3 className="whereDataInstrCardTitle">Electromagnetic Spectrometer</h3>
          <p className="whereDataInstrCardDesc">
            An optical, remote-sensing instrument that splits the light received from a target into component wavelengths for measuring and analyzing. Spectrometers can measure how much light of a specific wavelength is present.
          </p>
          <div className="whereDataInstrCardBody">
            <div className="whereDataInstrCardCol">
              <p className="whereDataInstrListLabel">Phenomena observed:</p>
              <ul className="static-data-ul">
                <li>Coronal Holes</li>
                <li>Sunspots</li>
                <li>Spectral Irradiance</li>
              </ul>
            </div>
            <div className="whereDataInstrCardCol">
              <p className="whereDataInstrListLabel">Mission Examples:</p>
              <ul className="static-data-ul">
                <li><a href="https://science.nasa.gov/mission/iris/" target="_Blank" rel="noreferrer">IRIS</a></li>
                <li><a href="https://science.nasa.gov/mission/hinode/" target="_Blank" rel="noreferrer">Hinode (Solar-B)</a></li>
                <li><a href="https://science.nasa.gov/mission/ace/" target="_Blank" rel="noreferrer">ACE</a></li>
                <li><a href="https://science.nasa.gov/mission/wind/" target="_Blank" rel="noreferrer">Wind</a></li>
                <li><a href="https://science.nasa.gov/mission/gold/" target="_Blank" rel="noreferrer">GOLD</a></li>
                <li><a href="https://science.nasa.gov/mission/twins" target="_Blank" rel="noreferrer">TWINS</a></li>
              </ul>
            </div>
          </div>
          <div className="whereDataInstrCardMedia">
            <VideoViewModal
              src={irisVid}
              type="video/webm"
              autoPlay
              caption="The Interface Region Imaging Spectrograph (IRIS) explorer is a spectrograph developed for NASA missions, this one designed for exploring the energization process in the solar chromosphere at higher resolution than previously possible. In the visualization presented here, the IRIS slit-jaw imager (SJI) takes images with two different filters, one at 1330 angstroms (gold color table), the other at 1400 angstroms (bronze color table), and these images are displayed overlaying corresponding imagery from the Solar Dynamics Observatory (SDO) 304 angstrom filter (grayscale)."
              credit="Credit: NASA's Scientific Visualization Studio"
            />
          </div>
        </div>

        {/* Card 4: Energetic Particle Detector */}
        <div className="whereDataInstrCard">
          <h3 className="whereDataInstrCardTitle">Energetic Particle Detector</h3>
          <p className="whereDataInstrCardDesc">
            An in-situ instrument that uses electric fields to capture and sort particles to be analyzed. A high-energy particle detector measures the energy spectra of energetic electrons, and the energy and composition of atomic nuclei. A low-energy charged-particle detector (LECP) is a mid-range instrument designed to characterize the composition, energies, and angular distributions of charged particles in interplanetary space and within planetary systems.
          </p>
          <div className="whereDataInstrCardBody">
            <div className="whereDataInstrCardCol">
              <p className="whereDataInstrListLabel">Phenomena observed:</p>
              <ul className="static-data-ul">
                <li>Cosmic Rays</li>
                <li>Solar energetic particle bursts</li>
              </ul>
            </div>
            <div className="whereDataInstrCardCol">
              <p className="whereDataInstrListLabel">Mission Examples:</p>
              <ul className="static-data-ul">
                <li><a href="https://science.nasa.gov/mission/solar-orbiter/" target="_Blank" rel="noreferrer">Solar Orbiter</a></li>
                <li><a href="https://science.nasa.gov/mission/voyager/voyager-1/" target="_Blank" rel="noreferrer">Voyager 1</a> and <a href="https://science.nasa.gov/mission/voyager-2/">Voyager 2</a></li>
                <li><a href="https://science.nasa.gov/mission/mms/" target="_Blank" rel="noreferrer">MMS</a></li>
              </ul>
            </div>
          </div>
          <div className="whereDataInstrCardMedia">
            <ImageViewModalWithZoom src={voyager1And2Data} alt="Voyager 1 and 2 data" />
            <p className="whereDataMediaCaption">
              These graphs compare data from identical instruments onboard NASA's Voyager 1 and Voyager 2 spacecraft as they each exited the heliosphere. Voyager 1 exited in 2012, and Voyager 2 exited in 2018.<br />
              Credit: NASA/JPL-Caltech
            </p>
          </div>
        </div>

        {/* Card 5: Magnetometer — no media */}
        <div className="whereDataInstrCard">
          <h3 className="whereDataInstrCardTitle">Magnetometer</h3>
          <p className="whereDataInstrCardDesc">
            An in-situ instrument that detects and measures the interplanetary and solar magnetic fields in the vicinity of the spacecraft. They typically can detect the strength of magnetic fields in three planes. As a magnetometer sweeps an arc through a magnetic field when the spacecraft rotates, an electrical signature is produced proportional to the strength and structure of the field. Magnetometers can be space-based or ground-based.
          </p>
          <div className="whereDataInstrCardBody">
            <div className="whereDataInstrCardCol">
              <p className="whereDataInstrListLabel">Phenomena observed:</p>
              <ul className="static-data-ul">
                <li>Solar wind magnetic holes</li>
                <li>Plasma waves in the magnetosphere</li>
                <li>Changes in Earth's magnetic field caused by geomagnetically-induced currents</li>
              </ul>
            </div>
            <div className="whereDataInstrCardCol">
              <p className="whereDataInstrListLabel">Mission Examples:</p>
              <ul className="static-data-ul">
                <li><a href="https://science.nasa.gov/mission/themis/" target="_Blank" rel="noreferrer">THEMIS</a></li>
                <li><a href="https://science.nasa.gov/mission/wind/" target="_Blank" rel="noreferrer">Wind</a></li>
                <li><a href="https://science.nasa.gov/mission/mms/" target="_Blank" rel="noreferrer">MMS</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Card 6: Electric Field Instrument — no media */}
        <div className="whereDataInstrCard">
          <h3 className="whereDataInstrCardTitle">Electric Field Instrument</h3>
          <p className="whereDataInstrCardDesc">
            An in-situ instrument that measures electric fields in space or on Earth. Electric fields are coupled with magnetic fields as part of the fundamental laws known as Maxwell's equations.
          </p>
          <div className="whereDataInstrCardBody">
            <div className="whereDataInstrCardCol">
              <p className="whereDataInstrListLabel">Phenomena observed:</p>
              <ul className="static-data-ul">
                <li>Particle acceleration associated with magnetic reconnection inside electron diffusion regions.</li>
              </ul>
            </div>
            <div className="whereDataInstrCardCol">
              <p className="whereDataInstrListLabel">Mission Examples:</p>
              <ul className="static-data-ul">
                <li><a href="https://science.nasa.gov/mission/themis/" target="_Blank" rel="noreferrer">THEMIS</a></li>
                <li><a href="https://science.nasa.gov/mission/mms/" target="_Blank" rel="noreferrer">MMS</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Card 7: Plasma Analyzer — full-width with image on the right */}
        <div className="whereDataInstrCard whereDataInstrCardFull">
          <div className="whereDataInstrCardFullLayout">
            <div className="whereDataInstrCardFullLeft">
              <h3 className="whereDataInstrCardTitle">Plasma Analyzer</h3>
              <p className="whereDataInstrCardDesc">
                An in-situ instrument that measures the density, composition, temperature, velocity, and three-dimensional distribution of plasmas, which are fluid-like "soups" of positive ions and electrons, that exist in interplanetary regions and within planetary magnetospheres.
              </p>
              <div className="whereDataInstrCardBody">
                <div className="whereDataInstrCardCol">
                  <p className="whereDataInstrListLabel">Phenomena observed:</p>
                  <ul className="static-data-ul">
                    <li>Flux Transfer Events</li>
                    <li>Bursty Bulk Flows</li>
                    <li>Co-rotating interaction regions</li>
                  </ul>
                </div>
                <div className="whereDataInstrCardCol">
                  <p className="whereDataInstrListLabel">Mission Examples:</p>
                  <ul className="static-data-ul">
                    <li><a href="https://science.nasa.gov/mission/solar-orbiter/" target="_Blank" rel="noreferrer">Solar Orbiter</a></li>
                    <li><a href="https://science.nasa.gov/mission/wind/" target="_Blank" rel="noreferrer">Wind</a></li>
                    <li><a href="https://science.nasa.gov/mission/mms/" target="_Blank" rel="noreferrer">MMS</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="whereDataInstrCardFullRight">
              <div className="whereDataInstrCardFullRightImgWrap">
                <ImageViewModalWithZoom src={windObservations} alt="Wind observations" />
              </div>
              <p className="whereDataMediaCaption">
                A 2D histogram representation of 25+ years of Wind observations. The panels are as follows from top to bottom: quasi-static magnetic field magnitude [nT], total ion number density [cm−3], and total ion bulk flow speed[km/s]. The shading corresponds to solar cycles 22 (green), 23 (blue), and 24 (magenta). The color bars indicate the counts in each bin.<br />
                Credit: Wilson, L. B., Brosius, A. L.,Gopalswamy, N., Nieves-Chinchilla,T., Szabo, A., Hurley, K., et al. (2021). A quarter century of wind spacecraft discoveries. Reviews of Geophysics,59, e2020RG000714.<br />
                <a href="https://doi.org/10.1029/2020RG000714" target="_blank" rel="noreferrer">https://doi.org/10.1029/2020RG000714</a>
              </p>
            </div>
          </div>
        </div>

      </div>

      <hr noshade={true} />
      <p>Visit the <a href="/downloading-and-acquiring">Step-by-Step User Guide</a> page for more information on available data products, how to use this site to access data, and common software used to read data formats. </p>
    </section>

  </div>
);

/**
* "Terms of Service" page
*/
const termsOfServiceHtml = (<div class="tos-container">
  <h2>Terms of Service</h2>
  <p class="lead">Effective Date: <strong>September 11 2025</strong></p>

  <p class="meta">Welcome to <a href="/">Heliodata</a>. By accessing or using this website, you agree to be bound by these Terms of Service. If you do not agree to these Terms, please do not use the site.</p>

  <h3>1. Purpose of the Site</h3>
  <p>Heliodata is an open-access gateway providing unified discovery and access to datasets from NASA and other agencies. The site enables browsing, searching, and downloading scientific and mission data for research, education, and informational use.</p>

  <h3>2. Use of the Site</h3>
  <ul>
    <li>The site is intended for research, educational, and informational purposes.</li>
    <li>You may browse, search, and download publicly available datasets without charge, subject to any dataset-specific license or attribution requirements noted in metadata.</li>
    <li>You agree not to use the site in a way that damages, disables, or impairs its operation, or interferes with other users' access or the site's infrastructure.</li>
    <li>Unauthorized attempts to access restricted portions of the site, servers, or connected systems are prohibited.</li>
  </ul>

  <h3>3. Data Sources, Licensing &amp; Attribution</h3>
  <p>Datasets available through Heliodata commonly originate from NASA missions, partner agencies, or third-party providers. Many NASA datasets are public domain; however, some third-party content may carry additional license or attribution requirements. Any such requirements will be indicated in the dataset metadata.</p>
  <p>Users are encouraged to acknowledge the original mission, instrument, data provider, and dataset identifier (e.g., DOI) when publishing results derived from these datasets.</p>

  <h3>4. No Warranties</h3>
  <p>The site and its contents are provided <strong>"as is"</strong> without warranty of any kind. Heliodata does not guarantee that data are accurate, complete, error-free, or suitable for any particular purpose. Scientific datasets may be reprocessed, corrected, or updated at any time. You are responsible for verifying data suitability for your use.</p>

  <h3>5. Limitation of Liability</h3>
  <p>To the maximum extent permitted by applicable law, Heliodata, its contributors, maintainers, sponsors, and affiliated institutions will not be liable for any direct, indirect, incidental, consequential, special, or punitive damages arising out of your access to or use of the site or any data obtained through the site. You assume responsibility for all outcomes resulting from your use of dataset content.</p>

  <h3>6. User Accounts (If Applicable)</h3>
  <ul>
    <li>Certain site features may require you to create an account. When creating an account you agree to provide accurate information and to maintain the confidentiality of your credentials.</li>
    <li>You are responsible for all activities that occur under your account. Notify us immediately of any unauthorized use.</li>
    <li>Heliodata reserves the right to suspend or terminate accounts that violate these Terms or applicable law.</li>
  </ul>

  <h3>7. Acceptable Use</h3>
  <p>You agree not to:</p>
  <ol>
    <li>Use the site to transmit malicious code, spam, or other materials that may harm the site or other users;</li>
    <li>Attempt to defeat or evade any security measures of the site;</li>
    <li>Impersonate another person or misrepresent your affiliation with any person or entity.</li>
  </ol>

  <h3>8. Modifications to the Service and Terms</h3>
  <p>Heliodata may modify, suspend, or discontinue the site (or any part of it) at any time without notice. We may update these Terms periodically. When we do, we will post the revised Terms on this page with a new "Effective Date." Continued use of the site after changes constitutes acceptance of the revised Terms.</p>

  <h3>9. Governing Law</h3>
  <p>These Terms are governed by and construed in accordance with the laws of the United States. If any provision of these Terms is found to be unenforceable, the remaining provisions will remain in full force and effect.</p>

  <h3>10. Privacy</h3>
  <p>Use of personal information is governed by our <a href="https://www.nasa.gov/about/highlights/HP_Privacy.html" target="_Blank" rel="noreferrer">Privacy Policy</a>. By using the site you agree that we may collect and process information in accordance with that policy.</p>

  <h3>11. Contact</h3>
  <p>If you have questions or concerns about these Terms, or to request enforcement or takedown of content, <a href="/contact-us" target="_Blank" rel="noreferrer">contact us.</a></p>

  <h3>12. Acknowledgements &amp; Funding</h3>
  <p>Heliodata may be supported by one or more institutions, grants, or funding agencies. Specific acknowledgements and funding sources will be listed elsewhere on the site as appropriate.</p>

  <hr />

  <p>Disclaimer: This Terms of Service is a general template intended to help start your legal documentation. It does not constitute legal advice. Consider having a qualified attorney review and adapt these Terms for your jurisdiction and institutional requirements.</p>
</div>
);


/**
 * Master object mapping page ID's to titles, taglines, and
 * body objects.
 *
 * Use "bodyHtml" property for a string of HTML, and "body" for
 * a JSX element.
 */
export const staticContent = [
  {
    "pageId": "about",
    "title": "Heliophysics Digital Resource Library (HDRL)",
    "tagline": "Where the Heliophysics System Observatory Comes Together",
    "body": aboutPageHtml,
  },
  {
    "pageId": "contactus",
    "title": "Contact Us",
    "tagline": "Questions or Feedback",
    "bodyHtml": contactUsHtml,
  },
  {
    "pageId": "learn-about-helio",
    "title": "Learn About Heliophysics",
    "tagline": "The Science of the Sun and Its Connection with the Solar System",
    "body": learnAboutHelioHtml,
  },
  {
    "pageId": "downloading-and-acquiring",
    "title": "Step-by-Step User Guide",
    "tagline": "A Path to Finding and Using Data for Scientific Discovery",
    "body": discoverAndDownloadPageHtml,
  },
  {
    "pageId": "terms-of-service",
    "title": "Terms of Service",
    "tagline": "",
    "body": termsOfServiceHtml,
  },
  {
    "pageId": "where-it-comes-from",
    "title": "Where the Data Comes From",
    "tagline": "NASA's Heliophysics Fleet and the Methods of Collecting Data",
    "body": whereTheDataComesFromHtml,
  },
];


/**
 * Master object mapping cards to title, cardImage, and link
 * body objects.
 *
 * Use "body" for description
 * a JSX element.
 */
export const staticCardListContent = [
  {
    "cardImage": helioviewerCardImg,
    "slug": "helioviewer",
    "title": "Helioviewer",
    "body": (<div>This web-based data visualization tool allows users to view images of the Sun from different spacecraft instruments, overlay features and events, and make screenshots and movies of solar phenomena.{/*It's like using a map app on the Sun! This tool supports exploratory data analysis and enables researchers to discover, pinpoint, and monitor solar events. A downloadable version called <a href="https://www.jhelioviewer.org/">JHelioviewer</a> with 3D streaming capability is available.*/}</div>),
    "link": "https://helioviewer.org/",
    "linkText": "Helioviewer",
  },
  {
    "cardImage": sswebCardImg,
    "slug": "orbitViewer",
    "title": "4D Orbit Viewer",
    "body": (<div>This interactive 4D Orbit Viewer showcases the locations and orbits of the celestial bodies in the solar system (Sun, Moon, planets) and over 100 spacecraft as 3D animations, with time added as a 4th dimension.{/* Data and plots can be downloaded through the viewer. Currently available coordinates are geocentric and heliocentric. Orbits and trajectories in other planetary coordinates will soon be added.*/}</div>),
    "link": "https://sscweb.gsfc.nasa.gov/4dorbit/",
    "linkText": "4D Orbit Viewer",
  },
  {
    "cardImage": sunImagesCardImg,
    "slug": "sunWavelengths",
    "title": "The Sun in Different Wavelengths",
    "body": (<div>This visualization from NASA's Scientific Visualization Studio highlights how the Solar Dynamics Observatory (SDO) captures images of the Sun in different wavelengths to study how solar activity is created and drives space weather.</div>),
    "link": "https://svs.gsfc.nasa.gov/vis/a000000/a004100/a004117/SDOargo_rotorzoom_HD1080.webmhd.webm",
    "linkText": "Sun in wavelenghts",
  },
  {
    "cardImage": heliophysicsTourCardImg,
    "slug": "helioFleet",
    "title": "Tour the Heliophysics Fleet",
    "body": (<div>This visualization presents orbits of current heliophysics satellites studying the space near Earth and throughout the solar system, spanning all the way to the Voyagers, located just outside the heliopause. Credit: NASA's Scientific Visualization Studio</div>),
    "link": "https://svs.gsfc.nasa.gov/vis/a000000/a005600/a005609/helio_fleet_2026_1080p60.mp4",
    "linkText": "Sentinels",
  },
];


export const staticObservatoryData = categorizedObservatoryData;
